// src/components/actionDashboard/common/CoverageTableHeader.tsx
import { FC } from "react";
import { headerPorps } from "src/components/actionDashboard/types";
import { COPAY_COMPLETED_CLAIMS_TABLE } from "./types";



const CopayCompletedClaimsHeader: FC<headerPorps> = ({ queryParam, changeIdOrder }) => {
  return (
    <thead className="sticky-top z-1">
      <tr className="text-center">
        {COPAY_COMPLETED_CLAIMS_TABLE.map((tableHeader, index) => (
           <th key={index}
          onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
        >
          <span role={tableHeader.value === '' ? "textbox" : "button"}
            className={
              tableHeader.value === '' ?
                'fw-bold fs-6 lh-base' :
                'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
            }
          >{tableHeader.label}
            {(queryParam as any).sort_by === tableHeader.value ? (
              <i className={`bi ${(queryParam as any).direction === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
            ) : null}
          </span>
        </th>
        ))}
      </tr>
    </thead>
  );
};

export default CopayCompletedClaimsHeader;
